class VariantLevelCopy extends HTMLElement {
    constructor () {
      super()

      this.containerEls = this.querySelectorAll('.variant-copy')
      this.initialiseVariantLevelCopy()

    }
  
    initialiseVariantLevelCopy () {

        if (this.containerEls.length < 1) return;

        const change = this.handleChange
        const items = this.containerEls
        const applyFromUrl = () => {
          const variantParam = new URLSearchParams(window.location.search).get('variant')
          change(variantParam, items)
        }

        applyFromUrl()

        // watch for url changes
        let previousUrl = window.location.href
        const observer = new MutationObserver(function() {
        if (window.location.href !== previousUrl) {
            previousUrl = window.location.href
            applyFromUrl()
            }
        });

        const config = {subtree: true, childList: true}

        observer.observe(document, config)

    }
  
    handleChange (variantId, items) {
        let matched = false
        items.forEach(el => {
            const id = el.getAttribute('data-id');
            el.classList.remove('variant-copy--show');
            if (variantId && String(variantId) === String(id)) {
                el.classList.add('variant-copy--show')
                matched = true
            }
        })
        if (!matched) {
          const firstWithData = [...items].find((el) => el.textContent.trim() !== '')
          if (firstWithData) firstWithData.classList.add('variant-copy--show')
        }
    }
  }
  
  customElements.define('variant-copy', VariantLevelCopy)